import React from "react";

const Header = () => {
  return (
    <header
      style={{
        background: "#ffffff",
        padding: "0px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        borderBottom: "3px solid #1b5e20",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          background: "#ffffff",
        }}
      >
        <img
          src="/images/logo1.png" // <-- your combined header image
          alt="CES Odisha Header"
          style={{
            width: "100%",
            height: "auto",
            maxHeight: "95px",
            objectFit: "contain",
          }}
        />
      </div>
    </header>
  );
};

export default Header;
